import { render } from "./AdditionalUBLocators.vue?vue&type=template&id=0fecb72b&ts=true"
import script from "./AdditionalUBLocators.ts?vue&type=script&lang=ts&external"
export * from "./AdditionalUBLocators.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__